module.exports = __webpack_public_path__ + "static/media/Img_18.3379050a.JPG";